import axios from './BaseService';

const SETTINGS_URL = `${process.env.REACT_APP_API_URL}/settings` || 'http://localhost:3001/settings';

export async function getSettings() {
    const response = await axios.get(SETTINGS_URL);
    return response.data;
}

// When the user is changing API keys and has 2FA on, the backend returns
// 401 { twoFactorRequired: true }. The caller prompts for a 6-digit code and
// retries with `totp` merged into the payload.
export async function updateSettings(settings, totp) {
    const payload = totp ? { ...settings, totp } : settings;
    const response = await axios.patch(SETTINGS_URL, payload);
    return response.data;
}